import React from 'react';
import { AnimatedNumber, useRevealInView } from '../lib/landingMotion';

const graphCards = [
    {
        title: 'Barbell Bench press',
        subtitle: 'Maximum weight',
        value: 30,
        delta: 8,
        valueFormatter: (value) => `${Math.round(value) >= 0 ? '+' : ''}${Math.round(value)}`,
        deltaFormatter: (value) => `${Math.round(value) >= 0 ? '+' : ''}${Math.round(value)}%`,
        path: 'M10 40 C24 52 38 57 52 54 C66 51 76 37 90 35 C108 32 130 35 149 35 C166 35 183 28 199 24 C213 20 228 22 239 29 C251 36 265 34 274 17 C281 4 289 4 304 4',
    },
    {
        title: 'Band Assisted Muscle-up',
        subtitle: 'Minimum assistance weight',
        value: -10,
        delta: -28,
        valueFormatter: (value) => `${Math.round(value)}`,
        deltaFormatter: (value) => `${Math.round(value)}%`,
        path: 'M12 11 C24 6 32 17 39 37 C46 57 57 61 72 56 C89 50 106 50 123 54 C140 57 154 65 168 67 C183 70 197 58 211 55 C225 53 234 63 248 67 C264 71 281 73 306 71',
    },
    {
        title: 'Hand stand',
        subtitle: 'Maximum time',
        value: 32,
        delta: 22,
        valueFormatter: (value) => `+00:${String(Math.max(0, Math.round(value))).padStart(2, '0')}`,
        deltaFormatter: (value) => `${Math.round(value) >= 0 ? '+' : ''}${Math.round(value)}%`,
        path: 'M10 55 C24 34 39 18 53 20 C67 22 71 55 88 56 C108 58 129 59 144 41 C158 24 171 23 181 23 C196 23 202 2 220 2 C234 2 242 15 256 17 C268 19 276 11 286 14',
    },
];

function GraphValue({ card, trigger, reducedMotion, delay }) {
    return (
        <AnimatedNumber
            target={card.value}
            duration={660}
            delay={delay}
            trigger={trigger}
            reducedMotion={reducedMotion}
            formatter={(value) => card.valueFormatter(value)}
        />
    );
}

function GraphDelta({ card, trigger, reducedMotion, delay }) {
    return (
        <AnimatedNumber
            target={card.delta}
            duration={620}
            delay={delay}
            trigger={trigger}
            reducedMotion={reducedMotion}
            formatter={(value) => card.deltaFormatter(value)}
        />
    );
}

function AnimatedSparkline({ path, trigger, reducedMotion }) {
    return (
        <svg className="capture-stat__sparkline" viewBox="0 0 316 78" preserveAspectRatio="none" aria-hidden="true">
            <path
                className={`capture-stat__sparkline-path ${trigger ? 'is-animated' : ''} ${reducedMotion ? 'is-reduced-motion' : ''}`.trim()}
                d={path}
                pathLength="1"
            />
        </svg>
    );
}

export default function CaptureJourneyGraphStack() {
    const animationMotion = useRevealInView({ threshold: 0.58, rootMargin: '0px 0px -18% 0px' });

    return (
        <div
            ref={animationMotion.ref}
            className="capture-stats"
            aria-label="Example TECNIQ progress summaries"
        >
            {graphCards.map((card, index) => {
                const animationDelay = 240 + index * 120;

                return (
                    <article
                        key={card.title}
                        className={`capture-stat ${animationMotion.isVisible ? 'is-animated' : ''}`.trim()}
                        data-reveal-item
                        style={{
                            '--delay': `${220 + index * 90}ms`,
                            '--metric-delay': `${animationDelay}ms`,
                            '--line-delay': `${animationDelay + 80}ms`,
                        }}
                    >
                        <div className="capture-stat__meta">
                            <p className="capture-stat__title">{card.title}</p>
                            <p className="capture-stat__subtitle">{card.subtitle}</p>
                        </div>

                        <div className="capture-stat__chart">
                            <AnimatedSparkline
                                path={card.path}
                                trigger={animationMotion.isVisible}
                                reducedMotion={animationMotion.prefersReducedMotion}
                            />
                        </div>

                        <div className="capture-stat__value">
                            <strong className="capture-stat__primary">
                                <GraphValue
                                    card={card}
                                    delay={animationDelay}
                                    trigger={animationMotion.isVisible}
                                    reducedMotion={animationMotion.prefersReducedMotion}
                                />
                            </strong>

                            <span className="capture-stat__delta">
                                <GraphDelta
                                    card={card}
                                    delay={animationDelay + 80}
                                    trigger={animationMotion.isVisible}
                                    reducedMotion={animationMotion.prefersReducedMotion}
                                />
                            </span>
                        </div>
                    </article>
                );
            })}
        </div>
    );
}